<template>
	<div class="with-100" v-if="list.length > 0">
		<mainTitle :title='$t("HomeObject.niceShop")' />
		<!-- 图一 -->
		<div class="flex-c" @click="onClickItem($event,1)">
			<div class="pointer m-8 image-one">
				<cacheImage class="image-one" :src="getImageUrlAtOrder(1)" />
			</div>

		</div>
		<div class="flex-c" v-if="list.length > 1">
			<!-- 图二 -->
			<div class="pointer m-4 image-other" @click="onClickItem($event,2)">
				<cacheImage :src="getImageUrlAtOrder(2)" />
			</div>
			<!-- 图三 -->
			<div v-if="list.length > 2" class="pointer m-4 image-other" @click="onClickItem($event,3)">

				<cacheImage :src="getImageUrlAtOrder(3)" />
			</div>
		</div>
		<div class="flex-c" v-if="list.length >3">
			<!-- 图4 -->
			<div class="pointer m-4 image-other" @click="onClickItem($event,4)">
				<cacheImage :src="getImageUrlAtOrder(4)" />
			</div>
			<!-- 图5 -->
			<div v-if="list.length > 4" class="pointer m-4 image-other" @click="onClickItem($event,5)">
				<cacheImage :src="getImageUrlAtOrder(5)" />
			</div>
		</div>

	</div>
</template>

<script>
	import main_title from '@/components/common/main_title.vue'

	import cache_image from '@/components/common/cache_image.vue'
	export default {
		name: 'NiceShop',
		components: {
			mainTitle: main_title,
			cacheImage: cache_image
		},
		data() {
			return {
				list: []
			}
		},
		mounted() {
			this.getDatas()
		},
		activated() {
			// this.getDatas()
		},
		methods: {
			getDatas() {

				this.$request.get('/shop/api/listPromotionGoods').then(response => {
					console.log("推荐信息", response)
					if (response.data.code == 200) {
						this.list = response.data.rows
					} else {
						this.list = []
					}
				}).catch(err => {
					console.log('err', err)
					this.list = []
				})
			},
			getImageUrlAtOrder(order) {

				let temp = JSON.parse(JSON.stringify(this.list))

				let subs = temp.filter(t => {
					return t.aOrder == order
				})
				if (subs.length > 0) {
					return subs[0].pic
				}
				let index = order - 1
				if (index < temp.length) { // 如果没填order, 就按索引取值
					return  temp[index].pic
				}
				return ''

			},
			onClickItem(e, order) {
				// console.log("click",order)
				let temp = JSON.parse(JSON.stringify(this.list))

				let subs = temp.filter(t => {
					if (t.aOrder != undefined) {
						return t.aOrder == order
					}

				})
				let item = undefined
				if (subs.length > 0) {
					item = subs[0]
				} else {
					let index = order - 1
					if (index < temp.length) {
						item = temp[index]
					}
				}
				if (item == undefined) {
					return
				}
				let link = item.outlink
				let url = item.url
				if (link == '2') {
					// 处理路径问题
					let routeUrl = url
					let id = ''
					if (url.indexOf('?') > 0) {
						routeUrl = url.slice(0, url.indexOf('?'))
						id = url.slice(url.indexOf('?') + 4)
						// console.log(routeUrl, id)
						this.$router.push({
							name: routeUrl,
							query: {
								id: id
							}
						})
					} else {
						this.$router.push({
							name: routeUrl
						})
					}

				} else {
					if (url.startsWith('http')) {
						window.open(url, '_blank')
					} else {
						window.open("http://" + url, '_blank')
					}

				}
			}
		}
	}
</script>

<style scoped>
	.pointer {
		/* border: 2px solid white; */
		border-radius: 8px;
		cursor: pointer;
	}

	.image-one {
		max-width: 1200px;
		height: 207px;
		border-radius: 8px;
	}

	.image-other {
		display: flex;
		max-width: 680px;
		width: 596px;
		height: 207px;
		border-radius: 8px;
	}
</style>



// WEBPACK FOOTER //
// src/views/hanscourse/niceshop/index.vue